// extracted by mini-css-extract-plugin
export default {"container":"MainCardsAd_container__goxkq","img":"MainCardsAd_img__KcgVl"};